import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getElectronicTrading, getTradingMessages } from 'store/modules/monitoring_store/actions';
import { ApplicationState } from 'store';
import { RequestState } from 'store/modules/monitoring_store/types';
import Loader from 'components/atoms/loader';
import MonitoringSellingPage from 'components/organisms/monitoring_selling_page';
import { Link } from 'react-router-dom';
import tabId from 'services/tabId';
import { getServiceSubscriptionStatus } from 'store/modules/service_subscription_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import { ServicesSubscriptionState } from 'store/modules/service_subscription_store/types';
import TradingMessages from '../trading_messages';
import BlockedSubscription from '../blocked_subscription';

interface ManagementMonitoringProps {
  electronicTradingId: number;
}

const ManagementMonitoring = (props: ManagementMonitoringProps) => {
  const MONITORING_SERVICE_ID = 2;
  const { electronicTradingId } = props;

  const dispatch = useDispatch();

  const requestMonitoring = useSelector<ApplicationState, RequestState>(
    (state) => state.storage.monitoring.request,
  );

  const { servicesSubscriptions, request } = useSelector<
    ApplicationState,
    ServicesSubscriptionState
  >((state) => state.storage.servicesSubscriptions);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    dispatch(getTradingMessages(electronicTradingId));
    dispatch(getElectronicTrading(electronicTradingId));
    dispatch(getServiceSubscriptionStatus(MONITORING_SERVICE_ID, profile?.currentCompany[tabId()]));
  }, []);

  const renderMonitoringService = () => {
    if (
      request.loading ||
      requestMonitoring.monitoring_messages.loading ||
      requestMonitoring.electronics_tradings.loading
    )
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '70vh ' }}
        >
          <Loader />
        </div>
      );

    if (!servicesSubscriptions.Monitoring?.current_signature) return <MonitoringSellingPage />;

    if (
      servicesSubscriptions.Monitoring?.has_any_signature &&
      !servicesSubscriptions.Monitoring?.current_signature
    )
      return <BlockedSubscription paralyzed={false} />;

    return (
      <>
        <div className="row py-3 border-bottom mx-0">
          <div className="col-md-2">
            <strong>Chat do Pregão</strong>
          </div>
          <div className="col-md-10 text-md-right text-center">
            <Link
              id="meus-boletins"
              to={`/facilitadores/monitoramento?electronic_trading_id=${electronicTradingId}`}
            >
              Acompanhar chat no Monitorar Chat
            </Link>
          </div>
        </div>
        <TradingMessages selectedTradingId={electronicTradingId} />
      </>
    );
  };

  return <div className="container-fluid px-0">{renderMonitoringService()}</div>;
};

export default ManagementMonitoring;
